import {useCallback} from "react";
import {useSearchParams} from "react-router-dom";
import {SEARCH_PARAMS} from "components/Layout/constants";
import useRecentSearchKeywords from "./useRecentSearchKeywords";

function useSearchAsset(value, onChangeInput) {
  const {saveRecentSearchKeyword} = useRecentSearchKeywords();
  const [searchParams, setSearchParams] = useSearchParams();
  const searchKeyword = searchParams.get(SEARCH_PARAMS.SEARCH);

  const searchAsset = value => {
    searchParams.set(SEARCH_PARAMS.SEARCH, value);
    setSearchParams(searchParams);
    saveRecentSearchKeyword(value);
  };

  const addSearchParamsKey = () => {
    searchParams.set(SEARCH_PARAMS.SEARCH, value);
    setSearchParams(searchParams);
  };

  const resetSearchKeyword = () => {
    searchParams.delete(SEARCH_PARAMS.SEARCH);
    onChangeInput?.("");
    setSearchParams(searchParams);
  };

  const resetSearchParamsOnDeleteValue = useCallback(
    e => {
      if (e.target.value?.length === 0 && searchKeyword) {
        searchParams.set(SEARCH_PARAMS.SEARCH, "");
        setSearchParams(searchParams);
      }
    },
    [searchKeyword, searchParams, setSearchParams],
  );

  return {addSearchParamsKey, resetSearchParamsOnDeleteValue, searchAsset, resetSearchKeyword};
}

export default useSearchAsset;
